import React, { useState, useEffect } from 'react';
import { Card, CardHeader, CardBody, CardFooter, Row, Col, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { TextBox } from 'devextreme-react/text-box';
import { Tooltip } from 'devextreme-react/tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CheckBox from 'devextreme-react/check-box';
import Cambio_Contraseña_Pases_Pendientes from './Cambio_Contraseña_Pases_Pendientes';
import { getPases, setAutorizarPase } from '../utils/api';
import { Hypnosis } from "react-cssfx-loading";
import { notificacionError, notificacionSuccess } from '../utils/alerts';

export default function Autorizar_Pases_Pendiente(props) {
    const [show, setShow] = useState(false);
    const [form, setForm] = useState({ password: "" });
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const [tooltipOpenClose, setTooltipOpenClose] = useState(false);
    const [chkState, setChkState] = useState(false);
    const [showCambio, setShowCambio] = useState(false);
    const [refresh, setRefresh] = useState(null);
    const [pase, setPase] = useState(null);
    const [usuario, setUsuario] = useState(null);
    const [loading, setLoading] = useState(false);
    const [tipo, setTipo] = useState(false);

    useEffect(() => {
        setShow(props.abrirModal);
        setPase(props.autorizar);
        setUsuario(sessionStorage.getItem("user"));
        setRefresh(props.refresh);
        return () => {
            setShow(false);
        }
    })

    const toolTip = () => setTooltipOpen(!tooltipOpen);
    const toolTipClose = () => setTooltipOpenClose(!tooltipOpenClose);

    const formChange = (campo, e) => {
        setForm({ ...form, [campo]: e.value });
    }

    const abrirCambioContraseña = () => {
        //if (chkState) {
        setShowCambio(true);
        //cerrarModal();
        //}
    }

    const cerrarCambioContraseña = (e) => {
        setShowCambio(e);
    }

    const cerrarModal = () => {
        setShow(false);
        props.cerrarModal(false);
        setChkState(false);
        setForm({ password: "" });
    }

    const chkChange = (e) => {
        setChkState(e.value);
    }

    const onEnterKey = (event) => {
        if (event.key === 'Enter') {
            autorizar();
        }
    }

    //METODO PARA AUTORIZAR
    const autorizar = () => {
        setLoading(true);
        if (form.password !== '') {
            setAutorizarPase(pase, usuario, form.password)
                .then(resp => {
                    if (resp.status === 200) {
                        if (resp.data) {
                            notificacionSuccess("Autorizado");
                            getPases(refresh)
                                .then(resp => {
                                    if (resp.status === 200) {
                                        if (resp?.data) {
                                            resp.data.forEach(e => {
                                                e.Almacen = e.Almacen === null ? "Sin almacen" : e.Almacen;
                                                e.Grupo = e.Grupo === null ? "Sin grupo" : e.Grupo;
                                                //e.Documento = e.Documento.substr(2, 1);
                                                let doc = null;
                                                switch (e.Documento) {
                                                    case "341":
                                                        doc = "Def CIA";
                                                        break;
                                                    case "342":
                                                        doc = "Def DEV";
                                                        break;
                                                    case "343":
                                                        doc = "Def CGO";
                                                        break;
                                                    case "344":
                                                        doc = "Def OTR";
                                                        break;
                                                    case "345":
                                                        doc = "Tmp CIA";
                                                        break;
                                                    case "346":
                                                        doc = "Tmp REP";
                                                        break;
                                                    case "347":
                                                        doc = "Tmp TRA";
                                                        break;
                                                    case "348":
                                                        doc = "Tmp OTR";
                                                        break;
                                                }
                                                e.DocumentoLetra = doc;
                                                e.NoDocumento = e.NoDocumento;
                                                e.Fecha = e.Fecha === null ? "Sin fecha" : e.Fecha;
                                                e.NoEmpleado = `${e.NoEmpleado} - ${e.NombreEmpleado}`;
                                                e.Estado = e.Estado;
                                                e.TipoPase = e.TipoPase;
                                                e.DescripcionPase = e.DescripcionPase === null ? "Sin descripción" : e.DescripcionPase;
                                                e.Autoriza = e.autoriza === null ? "Sin autorización" : e.Autoriza;
                                                e.FechaAutoriza = e.FechaAutoriza === null ? "Sin fecha" : e.FechaAutoriza;
                                            });
                                            props.dataUpdate(resp.data);
                                        }
                                    } else {
                                        throw new Error(resp.statusText);
                                    }
                                })
                                .catch(err => {
                                    setLoading(false);
                                    console.log(err);
                                    notificacionError("Intentelo nuevamente, si el error persite favor de comunicarse con el administrador del sistema");
                                });
                            cerrarModal();
                        } else {
                            notificacionError("Contraseña Incorrecta / Pase autorizado por favor actualicé la pagina");
                        }
                    } else {
                        throw new Error(resp.statusText);
                    }
                    setLoading(false);
                })
                .catch(err => {
                    setLoading(false);
                    console.log(err);
                    notificacionError("Intentelo nuevamente, si el error persite favor de comunicarse con el administrador del sistema");
                });
        } else {
            setLoading(false);
            notificacionError("Favor de ingresar una contraseña")
        }
    }

    return (
        <div>
            <Modal isOpen={show} toggle={cerrarModal} backdrop="static">
                <ModalHeader>Seguridad de Inventarios</ModalHeader>
                {loading ?
                    <Hypnosis width="100px" height="100px" style={{ margin: "0 auto", marginBottom: "1rem" }} />
                    :
                    <>
                        <ModalBody>
                            <Row>
                                <Col>
                                    <Card>
                                        <CardHeader>
                                            <div className="text-center">
                                                <h4>Inventarios</h4>
                                            </div>
                                        </CardHeader>
                                        <CardBody>
                                            {/* <Row>
                                        <Col sm={{ size: 12 }}>
                                            <label className="col-form-label fs-6 fw-bold">Acción</label>
                                            <TextBox
                                                showClearButton={true}
                                                placeholder="Acción"
                                                valueChangeEvent="keyup"
                                                onValueChanged={(e) => formChange("accion", e)}
                                                value={form.accion} />
                                        </Col>
                                    </Row> */}
                                            <Row>
                                                <Col sm={{ size: 12 }}>
                                                    <label className="col-form-label fs-6 fw-bold">Contraseña</label>
                                                    {/* <TextBox
                                                        style={{ WebkitTextSecurity: 'disc' }}
                                                        mode='tel'
                                                        showClearButton={true}
                                                        placeholder="Contraseña"
                                                        valueChangeEvent="keyup"
                                                        onValueChanged={(e) => formChange("password", e)}
                                                        value={form.password} /> */}
                                                    <input
                                                        name='password'
                                                        style={{ WebkitTextSecurity: 'disc' }}
                                                        type="tel"
                                                        inputMode='tel'
                                                        className="form-control"
                                                        placeholder='Contraseña'
                                                        onChange={(e) => formChange("password", e.target)}
                                                        onKeyUp={onEnterKey}
                                                        value={form.password} />
                                                </Col>
                                            </Row>
                                        </CardBody>
                                        <CardFooter className="text-center">
                                            {/* <CheckBox
                                        text="Cambiar/Crear Contraseña"
                                        value={chkState}
                                        onValueChanged={chkChange}
                                    /> */}
                                            <button className="btn btn-info small" onClick={abrirCambioContraseña}>Cambiar / Crear Contraseña</button>
                                        </CardFooter>
                                    </Card>
                                </Col>
                            </Row>
                        </ModalBody>
                        <ModalFooter>
                            <button id="btnAceptar"
                                className="btn btn-outline-success"
                                onClick={() => autorizar()}
                                onMouseEnter={toolTip}
                                onMouseLeave={toolTip}>
                                <FontAwesomeIcon icon="check" size="2x" />
                            </button>
                            <Tooltip
                                target="#btnAceptar"
                                position="top"
                                visible={tooltipOpen}
                                closeOnOutsideClick={false}
                            >
                                <div>Aceptar</div>
                            </Tooltip>
                            <button id="btnCancelarAutorizar"
                                className="btn btn-outline-danger"
                                onClick={cerrarModal}
                                onMouseEnter={toolTipClose}
                                onMouseLeave={toolTipClose}>
                                <FontAwesomeIcon icon="times" size="2x" />
                            </button>
                            <Tooltip
                                target="#btnCancelarAutorizar"
                                position="top"
                                visible={tooltipOpenClose}
                                closeOnOutsideClick={false}
                            >
                                <div>Cancelar</div>
                            </Tooltip>
                        </ModalFooter>
                    </>
                }
            </Modal>
            <Cambio_Contraseña_Pases_Pendientes abrirModal={showCambio} cerrarModal={cerrarCambioContraseña} />
        </div>
    )
}